// extracted by mini-css-extract-plugin
export default {"header":"SecurityView_header__ON6ui","referral":"SecurityView_referral__1sic7","referralText":"SecurityView_referralText__OnZ4y"};